window.addEventListener("DOMContentLoaded", () => {
    let announcementBar = document.querySelector(
        "#shopify-section-announcement-bar .announcement-bar.top"
    );

    let announcementItems = document.querySelectorAll('.announcement-bar')

    function headerAnnouncementOffset() {
        let offset = 0;
        if (announcementBar) {
            offset = announcementBar.offsetHeight;
        }

        document.querySelector("sticky-header").style.top = offset + "px";
        document.querySelector("#MainContent").style.top = offset + "px";
        document.querySelector("#MainContent").style.marginBottom =
            offset + "px";

        document.querySelector(".mainMenu").style.marginTop = "0px";
        if (window.innerWidth <= 960) {
            document.querySelector(".mainMenu").style.marginTop = offset + "px";
        }

        let productTitle = document.querySelector(
            ".productInfo .product-title"
        );
        if (productTitle) {
            productTitle.style.marginTop = offset + "px";
        }
    }

    if (announcementBar) {
        headerAnnouncementOffset();
        document.body.classList.add("announce-top");
        window.addEventListener("resize", headerAnnouncementOffset);


        const announcementWrapper = document.querySelector('.announcement-bar__outer')
        if(announcementItems.length > 1){
            new Swiper(announcementWrapper, {
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 0,
                autoplay: announcementWrapper.classList.contains("autoplay") || false,
                loop: true,
                effect: "fade",
            });
        }
    }
});
